
import {
  getContainerById,
  getContainerTypes,
  getState,
  getWebToken,
  postContainer,
  putContainer,
} from "@/service/container.service";
import { IdName } from "@/types";
import { AppError } from "@/types/app.type";
import { Container } from "@/types/container.type";
import { defineComponent } from "@vue/runtime-core";
import { ElForm } from "element-plus";
import { countries } from "@/storage/countris";
import { Aemet } from "@/types/aemet.type";
import { getAemet } from "@/service/aemet.service";

const errorMessage = "error.required";

export default defineComponent({
  components: {},
  props: {
    id: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      containerForm: {} as Container,
      containerTypes: [] as IdName[],
      populationTypes: [] as IdName[],
      typeName: "" as string,
      description: "" as string,
      officeId: undefined as undefined | number,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      CountrysListEs: [] as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      CountrysListIng: [] as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      listProvince: [] as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      provincesSelect: [] as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      provincesSelectNames: [] as any,
      finalName: "" as string,
      aemetList: [] as Aemet[],
      containerName: "" as string,
      artificial: [
        {
          id: 1,
          name: "Captación",
        },
        {
          id: 2,
          name: "Distribución",
        },
        {
          id: 3,
          name: "Saneamiento",
        },
        {
          id: 4,
          name: "Depuración",
        },
        {
          id: 5,
          name: "Urbano",
        },
        {
          id: 6,
          name: "Industrial",
        },
      ] as IdName[],
      natural: [
        {
          id: 1,
          name: "Río",
        },
        {
          id: 2,
          name: "Lago",
        },
        {
          id: 3,
          name: "Arroyo",
        },
        {
          id: 4,
          name: "Laguna",
        },
        {
          id: 5,
          name: "Embalse",
        },
        {
          id: 6,
          name: "Mar (Costa)",
        },
      ] as IdName[],
      environmentId: undefined as undefined | number,
      environments: [
        {
          id: 1,
          name: "Medio natural",
        },
        {
          id: 2,
          name: "Medio artificial",
        },
        {
          id: 3,
          name: "Oficina",
        },
      ] as IdName[],
      rules: {
        holder: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        containerType: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        locality: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
        aemetStations: [
          {
            required: false,
            message: this.$t(errorMessage),
            trigger: "blur",
          },
        ],
      },
    };
  },
  async mounted() {
    if (this.id) {
      this.containerForm = await getContainerById(this.id);
      this.containerForm.type = "Oficina";
    } else {
      this.containerForm = {} as Container;
    }
    this.containerForm.country = "España";
    this.containerTypes = await getContainerTypes();
    const { data } = await getAemet(undefined, undefined, undefined);
    this.aemetList = data;
  },
  methods: {
    /**
     * do save
     * @returns
     */
    async doSave(): Promise<Container> {
      // - validate
      const valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();

      if (!valid) {
        throw new Error(AppError.FORM_VALIDATION);
      }

      // - call service
      if (
        this.containerForm.containerType?.name !== undefined &&
        this.containerForm.locality !== undefined &&
        this.containerForm?.holder
      ) {
        let nameType = this.containerForm.containerType?.name.trim();
        // let holder = this.containerForm?.holder.trim();
        let locality = this.containerForm?.locality.trim();
        // this.containerForm.name = `${nameType} ${locality}`;
        this.containerForm.name = `${nameType} ${this.containerName}`;
      }
      let container;
      if (this.containerForm.id !== undefined) {
        if (this.environmentId) {
          this.containerForm.environment = this.environments[this.environmentId].name;
        }
        // if (this.typeName) {
        //   this.containerForm.type = this.typeName;
        // }
        container = await putContainer(this.containerForm);
      } else {
        container = await postContainer(this.containerForm);
      }

      return container;
    },

    update(item: IdName) {
      this.containerForm.type = "";
      if (item.id === 3) {
        this.containerForm.type = "Oficina";
      }
    },

    //Consultas a API para obtnecion de los datos de la locaclidad
    async getCountry() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.CountrysListEs = countries.countries.map((countri: any) => countri.es_name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.CountrysListIng = countries.countries.map((countri: any) => countri.name);
    },
    async getState() {
      let token = await getWebToken();
      // obtenemos el pais en ingles
      let paisIngles = countries.countries.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (pais: any) => pais.es_name === this.containerForm.country
      );

      if (paisIngles?.name !== undefined) {
        let estados = await getState(token.data.auth_token, paisIngles?.name);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.provincesSelectNames = estados.map((provinces: any) => provinces.state_name);
      }
    },
  },
});
